import miniCommonStrings from 'owa-strings/owa-mini-common-strings';
import React, { useState } from 'react';
import { getIsShadowMailbox } from 'mini-user-config/lib/getIsShadowMailbox';
import { LazyMultiAccountPopup } from 'multi-account';
import { observer } from 'mobx-react-lite';
import { type PersonaSize } from 'owa-persona';
import { UserPersonaControl } from 'mini-user-persona';

interface MultiAccountPopupWrapperProps {
    personaRef: React.RefObject<HTMLDivElement>;
}

const MultiAccountPopupWrapperBase = (props: MultiAccountPopupWrapperProps): JSX.Element => {
    const [showMultiAccountPopup, setShowMultiAccountPopup] = useState<boolean>(false);

    const onOpenMultiAccountPopup = () => {
        setShowMultiAccountPopup(true);
    };

    const closeMultiAccountPopup = () => {
        setShowMultiAccountPopup(false);
    };

    return (
        <>
            <UserPersonaControl
                personaRef={props.personaRef}
                size={1}
                onClickPersona={onOpenMultiAccountPopup}
                hideInitials={getIsShadowMailbox()}
                ariaLabel={miniCommonStrings.personaControlAriaLabel}
                ariaHasPopup
            />

            {showMultiAccountPopup && (
                <LazyMultiAccountPopup
                    closeMultiAccountPopup={closeMultiAccountPopup}
                    elementToFocusOnClose={props.personaRef}
                />
            )}
        </>
    );
};

export const MultiAccountPopupWrapper = observer(MultiAccountPopupWrapperBase);
